import { useStore } from 'stook'

export default function useGlobalInitData() {
  const [globalInitData, setGlobalInitData] = useStore<any>('GlobalInitData', {
    userDefaultDto: {},
    serviceCities: [],
    reserveGoingRecordDto: {},
    reserveAdviceDto: null,
    reserveMaintainItemDto: null,
    smartMaintainActivated: false,
    maintainUrl: '',
    appVersion: null
  })

  const setMergedInitData = (
    userDefaultDto
  ) => {
    setGlobalInitData((state) => {
      state.userDefaultDto = userDefaultDto
    })
  }

  const setServiceCitiesInitData = (serviceCities) => {
    setGlobalInitData((state) => {
      state.serviceCities = serviceCities
    })
  }

  const setReserveGoingRecordDtoInitData = (reserveGoingRecordDto) => {
    setGlobalInitData((state) => {
      state.reserveGoingRecordDto = reserveGoingRecordDto
    })
  }

  const setReserveMaintainItemDtoInitData = (reserveAdviceDto, reserveMaintainItemDto, maintainUrl, smartMaintainActivated, appVersion) => {
    setGlobalInitData((state) => {
      state.reserveAdviceDto = reserveAdviceDto;
      state.reserveMaintainItemDto = reserveMaintainItemDto;
      state.maintainUrl = maintainUrl ?? '';
      state.smartMaintainActivated = smartMaintainActivated ?? false;
      state.appVersion = appVersion ?? null;
    })
  }

  return {
    globalInitData,
    setMergedInitData,
    setServiceCitiesInitData,
    setReserveGoingRecordDtoInitData,
    setReserveMaintainItemDtoInitData,
  }
}
